import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AnvandareEditDTO } from "../../../common/models/anvandare/AnvandareEditDTO";
import { AnvandareListRequestDTO } from "../../../common/models/anvandare/AnvandareListRequestDTO";
import { AnvandareListResponseDTO } from "../../../common/models/anvandare/AnvandareListResponseDTO";
import { ApiClientService } from "../../../common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class AnvandareEditService {
    private readonly apiClientService = inject(ApiClientService);

    searchForAnvandare(param: AnvandareListRequestDTO): Observable<AnvandareListResponseDTO[]> {
        return this.apiClientService.get<AnvandareListResponseDTO[]>("azureanvandare/searchforanvandare", false, {
            firstName: param.firstName,
            lastName: param.lastName,
            raskUser: param.raskUser,
            sveaEmployee: param.sveaEmployee,
            userName: param.userName,
            mail: param.mail
        });
    }

    getAnvandareForEdit(userName: string) {
        return this.apiClientService.get<AnvandareEditDTO>("azureanvandare/getanvandareforedit", false, {
            userName: userName
        });
    }

    saveAnvandare(user: AnvandareEditDTO) {
        return this.apiClientService.post("azureanvandare/saveanvandare", user);
    }
}
